import { TGoogleRoutePointDirections } from "../../../api/types/Map";
import { APP_CONFIG } from "../../../constants/constants";

export function removeConsecutiveDuplicatePoints(
  points: TGoogleRoutePointDirections[],
  epsilon = 0 // allow tolerance if needed
  // Real GPS data often has micro-jitter like:
  // 28.613900
  // 28.613901
  // 28.613899
): TGoogleRoutePointDirections[] {
  if (!points || points.length === 0) return [];

  const result: TGoogleRoutePointDirections[] = [points[0]];

  for (let i = 1; i < points.length; i++) {
    const prev = result[result.length - 1];
    const curr = points[i];

    const isSame =
      Math.abs(prev.location.lat() - curr.location.lat()) <= epsilon &&
      Math.abs(prev.location.lng() - curr.location.lng()) <= epsilon;

    if (!isSame) {
      result.push(curr);
    }
  }
  if (APP_CONFIG.DEBUG.MAPS_GDIRECTIONSSERVICE) {
    console.log(
      "XXDIREC - [removeConsecutiveDuplicatePoints] from",
      points.length,
      "to",
      result.length
    );
  }

  return result;
}
